import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
    formatAmount,
    formatPrice,
    priceUnitLabel,
    type PriceUnit,
} from '../utils/product-pricing';

/**
 * Prices in the vendor's language: `price({ amount: 45.9, currency: 'EUR', unit: 'm2' })`
 * → "€45.90 / m²" (en) or "45,90 € / m²" (fr); `amount(0, 'EUR')` → "€0".
 */
export function useFormatPrice() {
    const { t, i18n } = useTranslation();
    const lang = i18n?.language || 'en';

    const price = useCallback(
        (value: { amount: number; currency: string; unit?: PriceUnit | null }) =>
            formatPrice(value, lang, (unit) => priceUnitLabel((key, fallback) => String(t(key, fallback ?? '')), unit, 'short')),
        [t, lang],
    );
    const amount = useCallback((value: number, currency: string) => formatAmount(value, currency, lang), [lang]);

    return { price, amount, lang };
}
